// YouTube-style hover preview for the expertos-videos cards: after a short
// hover delay, a muted inline <video> fades in over the poster and plays;
// on leave it pauses, rewinds and fades back to the poster.
// Delegated mouseover/mouseout so Owl carousel CLONES work (same reason
// videoModal.js uses delegation). The <video> is created lazily on first
// hover (preload="metadata") so nothing downloads until the user shows
// intent. Hover-capable pointers only — mobile keeps the plain poster.

document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return

  const HOVER_DELAY = 400
  const timers = new WeakMap()

  function getPreview(media) {
    let video = media.querySelector('.experto-card__preview')
    if (video) return video
    video = document.createElement('video')
    video.className = 'experto-card__preview'
    video.muted = true
    video.loop = true
    video.playsInline = true
    video.setAttribute('playsinline', '')
    video.preload = 'metadata'
    video.src = media.getAttribute('data-preview-src')
    const play = media.querySelector('.experto-card__play')
    media.insertBefore(video, play)
    return video
  }

  function stopPreview(media) {
    clearTimeout(timers.get(media))
    const video = media.querySelector('.experto-card__preview')
    media.classList.remove('is-previewing')
    if (video) {
      video.pause()
      try { video.currentTime = 0 } catch (e) {}
    }
  }

  document.addEventListener('mouseover', function (e) {
    const media = e.target.closest('[data-preview-src]')
    if (!media || media.contains(e.relatedTarget)) return
    clearTimeout(timers.get(media))
    timers.set(media, setTimeout(function () {
      const video = getPreview(media)
      const playPromise = video.play()
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {})
      }
      media.classList.add('is-previewing')
    }, HOVER_DELAY))
  })

  document.addEventListener('mouseout', function (e) {
    const media = e.target.closest('[data-preview-src]')
    if (!media || media.contains(e.relatedTarget)) return
    stopPreview(media)
  })

  // Opening the modal (click on the card) must kill the inline preview so
  // both videos don't play at once.
  document.addEventListener('click', function (e) {
    const media = e.target.closest('[data-preview-src]')
    if (media) stopPreview(media)
  })
})
